<template>
  <!-- -->
  <b-nav-item-dropdown id="dropdown-grouped" class="login-lang" variant="link" right no-caret>
    <template #button-content>
      <div class="d-flex cursor-pointer" variant="link">
        <img width="30" :src="currentLocale.img" alt="" />
        <p class="text-center mb-0 text-lang">
          {{ currentLocale.name }}
        </p>
      </div>
    </template>
    <b-dropdown-item
      v-for="(item, index) in locales"
      :key="index"
      @click="changeLang(item.locale)"
    >
      <div class="d-flex cursor-pointer" variant="link">
        <img width="30" :src="item.img" alt="" />
        <p class="text-center mb-0 ml-1">
          {{ item.name }}
        </p>
      </div>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from "bootstrap-vue";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.find((l) => l.locale === this.$i18n.locale);
    },
  },
  methods: {
    changeLang() {
      const lang = this.currentLocale.locale == "en" ? "vn" : "en";
      this.$store.commit("i18n/SET_LANG", lang);
      this.locale = lang;
    },
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [
      {
        locale: "en",
        img: require("@/assets/images/icon-login/icon-en.png"),
        name: "English",
        names: "EN",
      },
      {
        locale: "vn",
        img: require("@/assets/images/flags/vn.png"),
        name: "Việt Nam",
        names: "VN",
      },
    ];
    /* eslint-disable global-require */

    return {
      locales,
    };
  },
};
</script>
<style>
.login-lang .dropdown-menu {
  min-width: 1rem;
  transform-origin: center bottom;
  /* transition: all 0.7s; */
  transition-delay: 1s;
  left: -3px !important;
}

.ropdown-language-small .dropdown-menu {
  top: -26px !important;
  transform: translate3d(-65px, 45px, 0px) !important;
}
</style>
<style scope>
.text-lang {
  margin-left: 10px;
  font-size: 1.1em !important;
  min-width: 75px;
  color: #f1f2f2;
}
</style>
